module.exports = [
  require('./reviver')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/json/index.js
// module id = 1244
// module chunks = 0